class Componentes {
	constructor(){
		this.componentes = {};
	}

	define(elemento, Compositor){
		let els = document.querySelectorAll(elemento);

		if(els){
			this.componentes[elemento] = {
				seletor: elemento,
				compositor: Compositor,
				list: []
			};

			for(let el in els){
				this.componentes[elemento].list.push(new Compositor(els[el]));
			}
		}
	}
}

let elementosCustom = new Componentes();

$('[data-share]').click(function(e){
	e.preventDefault();
});

var mediaVerifyer = (function(){
	window.mediaSize = 'xs';

	function verifyMedia(){
		let w = screen.width;

		if(w < 576){
			window.mediaSize = 'xs';
		}
		
		if (w >= 576){
			window.mediaSize = 'sm';
		}
		
		if (w >= 768){
			window.mediaSize = 'md';
		}
		
		if (w >= 992){
			window.mediaSize = 'lg';
		}

		if (w >= 1200){
			window.mediaSize = 'xl';
		}
	}

	$(window).resize(function(){
		verifyMedia();
	})

	return verifyMedia();
})();